import { css } from 'styled-components';
import { LABEL_COLOR } from '../../../constants/colors';

export default {
  wrapper: ({ fixAutofill }) => css`
    margin-bottom: 24px;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active  {
        box-shadow: 0 0 0 30px ${fixAutofill} inset;
    }
  `,
  label: ({ status }) => css`
    font-size: 10px;
    color: ${LABEL_COLOR};
    margin-top: 2px;
    opacity: 0.7;

    ${status > 0
      && css`
        color: ${status === 2 ? 'red' : 'green'};
        opacity: 1;
      `};
  `,
  input: css`
    border: 0;
    border-radius: 0;
    outline: none;
    margin: 0;
    padding: 0;
    border-bottom: 1px solid #ccc;
    width: 100%;
    color: ${LABEL_COLOR};
    background-color: transparent;

    &:focus {
      border-bottom: 1px solid ${LABEL_COLOR};
    }
  `
};
